<cwc-tooltip *ngIf="config?.tooltip; else noTooltipTmp" [attr.content]="config?.tooltip" block designVersion="v2">
  <ng-content></ng-content>
</cwc-tooltip>

<ng-template #noTooltipTmp>
  <ng-content></ng-content>
</ng-template>
